import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import EventLogApi from '../../api/eventlog';
import { TEventLogTableFilterPayload } from '../../types/eventLogs';
import { EVENT_LOGS_MUTATIONS_NAME } from './name';
import { TEventLogStoreState } from './types';

export async function getEventLogs(
  context: ActionContext<TEventLogStoreState, unknown>,
  payload: TEventLogTableFilterPayload,
) {
  return await EventLogApi.search(payload.params, payload.abortController?.signal);
}

export async function getSeverities(context: ActionContext<TEventLogStoreState, unknown>) {
  const response = await EventLogApi.getSeverities();
  context.commit(getLocalState(EVENT_LOGS_MUTATIONS_NAME.setSeverities), response);
}

export async function getModules(context: ActionContext<TEventLogStoreState, unknown>) {
  const response = await EventLogApi.getModules();
  context.commit(getLocalState(EVENT_LOGS_MUTATIONS_NAME.setModules), response);
}

export async function getEntityTypes(context: ActionContext<TEventLogStoreState, unknown>) {
  const response = await EventLogApi.getEntityTypes();
  context.commit(getLocalState(EVENT_LOGS_MUTATIONS_NAME.setEntityTypes), response);
}
